import React, { useEffect, useRef } from "react";

function replaceScripts(container) {
  if (!container) {
    return;
  }

  const scripts = Array.from(container.querySelectorAll("script"));

  scripts.forEach(oldScript => {
    const newScript = document.createElement("script");

    Array.from(oldScript.attributes).forEach(attr => {
      newScript.setAttribute(attr.name, attr.value);
    });

    if (oldScript.textContent) {
      newScript.textContent = oldScript.textContent;
    }

    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

function FormEmbed({ title, content, form }) {
  const formRef = useRef(null);

  useEffect(() => {
    replaceScripts(formRef.current);
  }, [form]);

  return (
    <section className="content white-background centered-form-holder">
      <div className="forty-spacer"></div>

      {title && (
        <div className="centered-title-holder">
          <h3>{title}</h3>
        </div>
      )}

      {content && (
        <div
          className="centered-intro-text-holder"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}

      <div ref={formRef} dangerouslySetInnerHTML={{ __html: form }} />

      <div className="sixty-spacer"></div>
    </section>
  );
}

export default FormEmbed;
